import { render, staticRenderFns } from "./ServiceSearchBar.vue?vue&type=template&id=36c4f2f7&scoped=true"
import script from "./ServiceSearchBar.vue?vue&type=script&lang=js"
export * from "./ServiceSearchBar.vue?vue&type=script&lang=js"
import style0 from "./ServiceSearchBar.vue?vue&type=style&index=0&id=36c4f2f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c4f2f7",
  null
  
)

export default component.exports